// extracted by css-extract-rspack-plugin
export default {"jsonToggleWrapper":"jsonToggleWrapper-RjjzOI","headless":"headless-mHWQkH"};